import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/sections/SmoothScroll";
import Nav from "@/sections/Nav";
import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import Manifesto from "@/sections/Manifesto";
import Replaces from "@/sections/Replaces";
import Pillars from "@/sections/Pillars";
import Features from "@/sections/Features";
import VoiceReminder from "@/sections/VoiceReminder";
import Solutions from "@/sections/Solutions";
import Roadmap from "@/sections/Roadmap";
import Waitlist from "@/sections/Waitlist";
import FAQ from "@/sections/FAQ";
import Footer from "@/sections/Footer";

const Landing = () => {
  return (
    <SmoothScroll>
      <main className="relative bg-[color:var(--bg)] text-[color:var(--ink)]" data-testid="landing-page">
        <Nav />
        <Hero />
        <Marquee />
        <Manifesto />
        <Replaces />
        <Pillars />
        <Features />
        <VoiceReminder />
        <Solutions />
        <Roadmap />
        <Waitlist />
        <FAQ />
        <Footer />
      </main>
    </SmoothScroll>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        theme="light"
        toastOptions={{
          style: {
            background: "#ffffff",
            border: "1px solid rgba(10,10,31,0.1)",
            color: "#0A0A1F",
            fontFamily: "var(--font-body)",
            boxShadow: "0 20px 40px -20px rgba(30,58,196,0.2)",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
